// 계정별 상담 히스토리 API 호출 모음.
// 모든 호출은 apiFetch<T>를 통해 JWT·refresh 횡단 관심사를 재사용한다.

import { apiFetch } from '~/api/client'
import type {
    ChatProfile,
    ChatSessionSummary,
    StoredChatMessage,
} from '~/api/types'

/** 세션과 그 대화 메시지를 삭제한다(204). 본인 소유가 아니면 403. */
export function deleteChatSession(sessionId: string): Promise<void> {
    return apiFetch<void>(
        `/chat/sessions/${encodeURIComponent(sessionId)}`,
        { method: 'DELETE' }
    )
}

/** 현재 계정의 상담 세션 목록(updatedAt 내림차순). */
export function listChatSessions(
    profile: ChatProfile
): Promise<ChatSessionSummary[]> {
    return apiFetch<ChatSessionSummary[]>(
        `/chat/sessions?profile=${encodeURIComponent(profile)}`
    )
}

/** 세션 단건의 저장된 메시지 목록(createdAt 오름차순). */
export function getChatMessages(
    sessionId: string
): Promise<StoredChatMessage[]> {
    return apiFetch<StoredChatMessage[]>(
        `/chat/sessions/${encodeURIComponent(sessionId)}/messages`
    )
}
